import { query, types, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';

export const getLocationSalesDataQuery = (location_id: string, dateFrom: string, dateTo: string) => gql`
  ${query({
    locations_by_pk: params(
      { id: rawString(location_id) },
      {
        id: types.string,
        name: types.string,
        orders_served: params(
          {
            where: {
              created_at: { _gte: rawString(dateFrom), _lte: rawString(dateTo) },
              paid: { _eq: true },
            },
          },
          [
            {
              id: types.string,
              order_number: types.string,
              location_id: types.string,
              organisation_id: types.string,
              table_number: types.number,
              covers: types.number,
              created_by: types.string,
              created_at: types.string,
              quick_sale: types.boolean,
              paid: types.boolean,
              total: types.number,
              tax: types.number,
              discounts: types.custom<any[]>(),
              refunds: types.custom<any[]>(),
              service_charge: types.number,
              status: types.string,
            },
          ]
        ),
        orders_served_aggregate: params(
          {
            where: {
              location_id: { _eq: rawString(location_id) },
              created_at: { _gte: rawString(dateFrom), _lte: rawString(dateTo) },
              paid: { _eq: true },
            },
          },
          {
            aggregate: {
              sum: {
                covers: types.number,
                service_charge: types.number,
                table_number: types.number,
                tax: types.number,
                total: types.number,
              },
              count: types.number,
            },
          }
        ),
      }
    ),
  })}
`;
